import styled, { css } from 'styled-components'
import { ReactComponent as ChevronRight } from '@sketch/icons/chevron-right-17'

/**
 * Shared by the host's implementation of the inspector's `componentLink`.
 *
 * Lives outside `components/` so that the application can style its link
 * without importing the whole visual layer — the link is wired up eagerly,
 * while the sidebar itself is loaded on demand.
 */
export const colorVariableLinkStyles = css`
  display: flex;
  align-items: center;

  font-weight: 400;
`

/**
 * The trailing chevron on a row that links out to a component's document.
 *
 * Shared with the application, which renders the same row for text and layer
 * styles as this package does for colour variables.
 */
export const ComponentLinkChevron = styled(ChevronRight)`
  flex: none;
  height: 17px;
  margin-left: auto;
  padding-left: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`
